const FILTERS_BLACKLIST = [
  'ss_on_sale',
  'ss_days_since_published',
  'ss_days_since_created',
  'tags_neckline',
  'variant_size'
]

const RANGE_INDICATOR = '<->'

const SIZE_FILTER_FIELD = 'variant_mfield_utopia'
const PRICE_FILTER_FIELD = 'ss_price'

const parseFiltersFromResults = (results) => {
  if (!results?.facets) return { fetchedFilters: [], sizeFilters: [] }
  const whiteListedFilters = results.facets.filter((facet) => {
    return !FILTERS_BLACKLIST.some((field) => field === facet.field)
  })
  const { otherFilters, sizeFilters } = separateSizeFilters(whiteListedFilters)
  return { fetchedFilters: otherFilters, sizeFilters }
}

const separateSizeFilters = (filters) => {
  const sizeFilters = filters.filter((filter) => filter.field.startsWith(SIZE_FILTER_FIELD))
  const otherFilters = filters.filter((filter) => !filter.field.startsWith(SIZE_FILTER_FIELD))
  return { sizeFilters, otherFilters }
}

export { parseFiltersFromResults, separateSizeFilters, PRICE_FILTER_FIELD, RANGE_INDICATOR }
